import { createAsyncThunk } from "@reduxjs/toolkit";

import { ApiService } from "../../service/ApiService";

export const getContent = createAsyncThunk(
  "mainPage/getContent",
  async (_, { rejectWithValue }) => {
    try {
      return await ApiService.getContentForForm();
    } catch (e) {
      return rejectWithValue(e.response.data.error);
    }
  },
);
